<template>
	<div>
		<modalconfirm supplier ref="modalconfirmPO" @action="proccessPO"/>
		<modaldetail :dialog="dialogDetail" @hideDialog="() => { dialogDetail = false }"></modaldetail>
		<modalPrint :dialog="dialogPrint" @hideDialog="() => { dialogPrint = false }"></modalPrint>
		<div class="d-flex justify-space-between">
			<div class="text-h5">Data Pemesanan</div>
		</div>
		<div v-if="loading">
			<loading-card-supplier></loading-card-supplier>
		</div>
		<div v-if="!loading">
			<v-card class="mt-3 mb-3" outlined>
				<v-list color="grey lighten-3"  class="pa-3">
					<v-list-item dense class="px-1">
						<div>
							<v-tabs color="cyan darken-2" background-color="grey lighten-3" class="change-display" height="40">
								<v-tab @click="cardDisplay = true">
									<v-icon>mdi-card-bulleted</v-icon>
								</v-tab>
								<v-tab @click="cardDisplay = false">
									<v-icon>mdi-table</v-icon>
								</v-tab>
							</v-tabs>
						</div>
						<v-spacer></v-spacer>
						<v-btn text depressed class="cyan darken-2 white--text mr-2" @click="exportData">
							<v-icon>mdi-export</v-icon>
							<div class="pl-2 text-capitalize">Export</div>
						</v-btn>
						<v-btn text depressed class="cyan darken-2 white--text" @click="dropfilter = !dropfilter">
							<v-icon>mdi-filter</v-icon>
							<div class="pl-2 text-capitalize">Filter</div>
						</v-btn>
					</v-list-item>
				</v-list>
			</v-card>
			<v-slide-y-transition>
				<v-card outlined class="mb-3" v-if="dropfilter">
					<v-col cols="12" class="px-3">
						<v-row>
							<v-col cols="12" md="3" >
								<v-text-field color="cyan darken-2" outlined dense hide-details label="Kode Pemesanan" v-model="po_code.value"></v-text-field>
							</v-col>
							<v-col cols="12" md="4" >
								<v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field outlined dense :value="convertDate(tanggalPO)" label="Tanggal Pemesanan" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hint="Bisa pilih range tanggal" hide-details></v-text-field>
									</template>
									<v-date-picker range color="cyan darken-2" v-model="tanggalPO"></v-date-picker>
								</v-menu>
							</v-col>
							<v-col cols="12" md="5">
								<v-autocomplete color="cyan darken-2" item-text="status" item-value="code" outlined dense hide-details v-model="po_status.value" :items="status_list" label="Status" class="width-0" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete color="cyan darken-2" outlined dense hide-details v-model="po_warehouse.value" :items="optionWarehouse" item-text="warehouse_name" item-value="warehouse_id" label="Pemesan" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3">
								<v-autocomplete color="cyan darken-2" outlined dense hide-details v-model="payment_type.value" :items="payment_list" label="Pembayaran" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
							</v-col>
							<v-col cols="12" md="3"></v-col>
							<v-col cols="12" md="3" class="text-right">
								<v-btn outlined color="grey darken-1" dark class="text-capitalize" @click="resetFilter()">Reset</v-btn>
								<v-btn depressed color="cyan darken-2" dark class="ml-2 text-capitalize" @click="cari()">Cari</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card>
			</v-slide-y-transition>
			<v-card outlined v-show="!cardDisplay">
				<v-data-table dense loading :headers="headers" :items="listPO" hide-default-footer :options.sync="option" :server-items-length="poPagination.total_data" disable-pagination>
					<template v-slot:item.po_status_wh_approved_datetime="{ item }">
						<div class="pt-2">{{ item.po_status_wh_approved_datetime | tanggalid }}</div>
						<div class="pt-3 pb-3">
							<v-btn x-small dense text color="grey darken-1" class="pl-0" @click="printPO(item.po_code)"><v-icon>mdi-printer</v-icon></v-btn>
							<!-- <v-btn x-small text color="cyan darken-2" class="pl-0"><v-icon>mdi-file-document-outline</v-icon></v-btn>
							<v-btn x-small dense text color="grey darken-1" class="pl-0"><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn> -->
						</div>
					</template>
					<template v-slot:item.po_code="{ item }">
						<div>{{ item.po_code }}</div>
					</template>
					<template v-slot:item.customer="{ item }">
						<div class="pt-2 pb-2">
							<div>{{ item.warehouse_name }}</div>
							<div class="pt-1"><v-icon small>mdi-phone</v-icon><span class="pl-2">{{ item.warehouse_mobilephone }}</span></div>
							<div class="pt-1"><v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ item.warehouse_address }}</span></div>
						</div>
					</template>
					<template v-slot:item.po_payment_method="{ item }">
						<div class="text-capitalize">{{ item.po_payment_method }}</div>
					</template>
					<template v-slot:item.po_status="{ item }">
						<div class="pt-2 text-capitalize">{{ item.po_status | toStatusPOWH }}</div>
						<div class="pt-2 pb-2">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn class="mr-1" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(item.po_code)">
										<v-icon dark>mdi-text-box-search</v-icon>
									</v-btn>
								</template>
								<span>Detail</span>
							</v-tooltip>
							<v-tooltip bottom v-if="item.po_status == 'wh_approved'">
								<template v-slot:activator="{ on, attrs }">
									<router-link :to="{ name: 'approval-penjualan', params: { code: item.po_code }}" class="text-deco">
										<v-btn class="mr-1" fab dark x-small depressed color="cyan darken-2 white" v-bind="attrs" v-on="on">
											<v-icon dark>mdi-check</v-icon>
										</v-btn>
									</router-link>
								</template>
								<span>Proses Pemesanan</span>
							</v-tooltip>
						</div>
					</template>
					<template v-slot:progress>
						<div>
						</div>
					</template>
					<template v-slot:loading>
						<div class="py-3" v-if="!poPagination">
							<loading-data-cyan></loading-data-cyan>
						</div>
						<div class="py-3" v-else>
							<not-found-cyan></not-found-cyan>
						</div>
					</template>
				</v-data-table>
			</v-card>
			<div v-show="cardDisplay">
				<v-card class="mb-3" outlined v-for="po in listPO" :key="po.po_id">
					<v-list color="grey lighten-3" class="pt-0 pb-0">
						<v-list-item dense>
							<v-list-item-content class="grey--text text--darken-2">
								Kode Pemesanan {{ po.po_code }}
							</v-list-item-content>
							<v-spacer></v-spacer>
							<v-btn small depressed color="cyan darken-2 white--text" @click="printPO(po.po_code)">
								<v-icon>mdi-printer</v-icon>
								<div class="pl-2 text-capitalize">Print</div>
							</v-btn>
						</v-list-item>
					</v-list>
					<v-list-item>
						<v-list-item-content>
							<v-layout wrap>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Pemesan</div>
									<div class="subtitle-2">{{ po.warehouse_name }}</div>
									<div class="body-2 pt-3">
										<v-icon small>mdi-phone</v-icon><span class="pl-2">{{ po.warehouse_mobilephone }}</span>
									</div>
									<div class="body-2 pt-1">
										<v-icon small>mdi-map-marker</v-icon><span class="pl-2">{{ po.warehouse_address }}</span>
									</div>
								</v-flex>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Tanggal Pemesanan</div>
									<div class="subtitle-2">{{ po.po_status_wh_approved_datetime | tanggaljam }}</div>
								</v-flex>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Pembayaran</div>
									<div class="subtitle-2 text-capitalize">{{ po.po_payment_method }}</div>
								</v-flex>
								<v-flex xs6 sm6 md3>
									<div class="body-2 oppacity-75">Status</div>
									<div class="subtitle-2">{{ po.po_status | toStatusPOWH }}</div>
									<div class="pt-3 d-flex">
										<div class="pr-1">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn class="mr-1" fab dark x-small depressed color="green darken-1" v-bind="attrs" v-on="on" @click.stop="getDetail(po.po_code)">
														<v-icon dark>mdi-text-box-search</v-icon>
													</v-btn>
												</template>
												<span>Detail</span>
											</v-tooltip>
										</div>
										<div>
											<v-tooltip bottom v-if="po.po_status == 'wh_approved'">
												<template v-slot:activator="{ on, attrs }">
													<router-link :to="{ name: 'approval-penjualan', params: { code: po.po_code }}" class="text-deco">
														<v-btn class="mr-1" fab dark x-small depressed color="cyan darken-2 white" v-bind="attrs" v-on="on">
															<v-icon dark>mdi-check</v-icon>
														</v-btn>
													</router-link>
												</template>
												<span>Proses Pemesanan</span>
											</v-tooltip>
										</div>
									</div>
								</v-flex>
							</v-layout>
						</v-list-item-content>
					</v-list-item>
				</v-card>
				<v-card outlined v-if="listPO.length < 1">
					<div class="py-3">
						<not-found-cyan></not-found-cyan>
					</div>
				</v-card>
			</div>
			<div class="pt-5" v-if="poPagination.total_page > 1 && listPO.length > 0">
				<v-row>
					<v-col cols="10" md="11" class="py-0 d-flex justify-end">
						<v-pagination v-model="page" :length="poPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus" color="cyan darken-2" @input="changePage"></v-pagination>
					</v-col>
					<v-col cols="2" md="1" class="py-0 pl-0">
						<v-autocomplete :items="listLimit" v-model="limit" hide-details class="mt-0" label="Item" color="cyan darken-2" item-color="cyan darken-4" @input="changeLimit"></v-autocomplete>
					</v-col>
				</v-row>
			</div>
		</div>
	</div>
</template>

<script>
import {mapActions,  mapState, mapMutations} from 'vuex'
import modalconfirm from '@/components/ModalConfirm'
import modaldetail from './ModalDetailPO'
import modalPrint from '@/views/MLsupplier/po/PrintPO'

export default {
	inject: ['theme'],
	components: {
		modalconfirm, modaldetail, modalPrint
	},
	data() {
		return {
			cardDisplay: true,
			menu: false,
			loading: true,
			tanggalPO: [],
			payment_list: ['Lunas', 'Tempo'],
			OptionStatusPO: ['wh_approved', 'supp_approved', 'supp_rejected', 'supp_processed', 'closed'],
			po_code: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_code'
			},
			po_date: {
				value:'',
				comparison: 'bet',
				type: 'date',
				field: 'po_status_wh_approved_datetime'
			},
			po_warehouse: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_warehouse_id'
			},
			payment_type: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_payment_method'
			},
			po_status: {
				value:'',
				comparison: '=',
				type: 'string',
				field: 'po_status'
			},
			sortBy: 'po_status_wh_approved_datetime',
			sortDir: 'DESC',
			page: 1,
			limit: 10,
			listLimit: [ '5', '10', '20', '50', '100' ],
			dropfilter: false,
			dialogConfirm: false,
			dialogDetail: false,
			dialogPrint: false,
			headers: [
			{ text: 'Tanggal Pemesanan', align: 'start', value: 'po_status_wh_approved_datetime', width: '15%' },
			{ text: 'Kode Pemesanan', value: 'po_code', width: '10%' },
			{ text: 'Pemesan', value: 'customer', sortable: false, width: "40%"},
			{ text: 'Pembayaran', value: 'po_payment_method', width: '15%' },
			{ text: 'Status', value: 'po_status', width: '20%'  },
			],
			params:[],
			procces_po_id: '',
			poProccess : '',
		}
	},
	computed: {
		...mapState('poSupplier', ['listPO', 'poPagination', 'optionWarehouse']),
		...mapState('authSupplier', ['userData']),

		status_list() {
			return this.OptionStatusPO.map( (el) => {
				return {
					code: el,
					status: this.$options.filters.toStatusPOWH(el)
				}
			})
		}

	},
	methods: {
		...mapActions('poSupplier', ['getPO', 'rejectPO', 'deletePO', 'getDetailPO', 'exportPO', 'getOptionWarehouse']),
		...mapMutations('poSupplier', ['clearDataPO']),
		...mapActions('commonSupplier', ['getLetterHeader']),

		getData() {
			this.getPO().then(() => {
				this.getOptionWarehouse().then(() => {
					this.loading = false
				})
			})
		},
		exportData(){
			this.exportPO(this.queryString({params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		resetFilter(){
			this.po_code.value = ''
			this.po_date.value = ''
			this.tanggalPO = []
			this.po_warehouse.value = ''
			this.payment_type.value = ''
			this.po_status.value = ''
			this.getPO(this.queryString({limit:this.limit, page: 1}))
		},
		cari(){
			this.params = []
			if (this.po_code.value)
				this.params.push(this.po_code)

			if (this.po_date.value){
				if (this.po_date.value.length > 1) {
					this.po_date.value.sort()
					let date = this.po_date.value.join('::')
					this.po_date.value = date
				}
				this.params.push(this.po_date)
			}

			if (this.po_warehouse.value)
				this.params.push(this.po_warehouse)

			if (this.payment_type.value)
				this.params.push(this.payment_type)

			if (this.po_status.value)
				this.params.push(this.po_status)
			this.getPO(this.queryString({limit:this.limit, page: 1, params:this.params}))
		},
		approve(val){
			this.procces_po_id = val
			this.poProccess = 'approve'
			let msg = "Yakin akan memproses Pemesanan ini?"
			this.$refs.modalconfirmPO.showConfirm()
			this.$refs.modalconfirmPO.setMessage(msg)
		},
		reject(val){
			this.procces_po_id = val
			this.poProccess = 'reject'
			let msg = "Yakin akan membatalkan Pemesanan ini?"
			this.$refs.modalconfirmPO.showConfirm()
			this.$refs.modalconfirmPO.setMessage(msg)
		},
		proccessPO(){
			if (this.poProccess == 'approve') {
				this.approvePO(this.procces_po_id)
			} else if (this.poProccess == 'reject') {
				this.rejectPO(this.procces_po_id)
			}
			this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			this.$refs.modalconfirmPO.hideConfirm()
		},
		changePage(page) {
			this.page = page
			this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
		},
		changeLimit(limit) {
			this.limit = limit
			this.page = 1
			this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params}))
		},
		getDetail(code){
			this.getDetailPO(code).then(()=> {
				this.dialogDetail = true
			})
		},
		async printPO(code) {
			await this.getLetterHeader({
				supplier_id: this.userData.user_supplier_supplier_id
			})
			await this.getDetailPO(code).then(()=> {
				this.dialogPrint = true
			})
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', `Pemesanan`);
		this.getData()
	},
	beforeDestroy() {
		this.clearDataPO()
	},
	watch: {
		tanggalPO(val) {
			this.po_date.value = val
		},
		option(val, old) {
			this.sortBy = val.sortBy[0]
			this.sortDir = val.sortDesc[0] ? 'ASC' : 'DESC'
			this.page = 1
			if (this.sortBy || (!this.sortBy && Object.keys(old).length > 0)) {
				this.getPO(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
			}
		}
	}
}
</script>